<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 23/01/2019 12:36AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li style="color:green">Added Game by Game shots graph.<span style="color:darkorange"> Beware some games are missing data i.e. NOT / GUI / GLAS Away games. Also, Game By Game won't account for the global filter below. TODO!</span></li>
            <li style="color:green">Added Chunked 5 Game shots graph.<span style="color:darkorange"> ''</span></li>
            <li style="color:green">Added Rolling shots graph.<span style="color:darkorange"> ''</span></li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="shots"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   <TeamShotMap></TeamShotMap>
    <section id="players">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Shotss" heading="Shots" v-bind:headers="ShotsPlayerHeadings" v-bind:tableData="sortByShotsData">
          <template slot="filter">
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
              <select v-model="FilterSelected"  @change="sortByShotsData">
                <option v-for="option in ShotsPlayerFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
          <label class="label">Situation</label>
          <div class="control">
            <div class="select">
              <select v-model="SituationSelected"  @change="fetchSeasonStats">
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'bar'" :data="chartData" :options="bar_options" style=""></chart>
          </div>
        </data-table>
      </div>
    </section>
    <section id="player_shotmap">
      <div class="is-parent is-vertical">
        
        <data-table  defaultShow="true" id="Shotss" heading="Player Shotmap" v-bind:headers="PlayerShotmapHeadings" v-bind:tableData="sortByPlayerShotmapData">
         <template slot="filter">
          <div>
            <label class="label">Player(s)</label>
            <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true" @close="fetchSeasonShotmaps">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
            </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
          </div>
          <div>
            <label class="label">Shot Type(s)</label>
            <multiselect v-model="ShotTypeSelected" :options="ShotTypeOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Select Shot Type(s)" label="name" track-by="name" :preselect-first="true" @close="fetchSeasonShotmaps">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="ShotTypeSelected.length &amp;&amp; !isOpen">{{ ShotTypeSelected.length }} options selected</span></template>
            </multiselect>
           <!--<pre class="language-json"><code>{{ ShotTypeSelected  }}</code></pre>-->
          </div>
          <label class="label">Situation</label>
          <div class="control">
            <div class="select">
              <select v-model="SituationSelected"  @change="fetchSeasonShotmaps">
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>

          <button class="button is-primary" @click="UseHeatmap = !UseHeatmap; fetchSeasonShotmaps()">Heatmap / Shotmap</button>
          <div class="columns">
          <div class="column is-half is-centered">
              <label v-if="UseHeatmap" class="label">Point Radius</label>
              <div v-if="UseHeatmap" class="control">
                <input type="number" class="input" v-model="RadiusSelected" min=1 max=150 @change="renderHeatmap">
              </div>
          </div>
          <div class="column is-half is-centered">
            <label  v-if="UseHeatmap" class="label">Point Blur</label>
            <div v-if="UseHeatmap" class="control">
              <input type="number" class="input" v-model="BlurSelected" min=1 max=150 @change="renderHeatmap">
            </div>
          </div>
          </div>
          </template>
          <div slot="graph">
            <div class="columns is-centered">
            <div class="column is-half">
              <canvas id="shotmap_key" ref="shotmap_key" height="50"></canvas>
            </div>
            </div><div class="columns is-centered">
            <div class="column is-half">
              <canvas id='shotmap' class="is-canvas-responsive" ref="player_shot_canvas" width="600" height="530" style="background: url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"></canvas>
            </div>
            </div>
          </div>
        </data-table>
      </div>
    </section>
    <section id="gameByGame">
       <div class="is-parent is-vertical">
        <data-table  id="GameByGame" heading="Game By Game">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true" @close="fetchSeasonShotmaps">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
    <section id="chunked">
       <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Chunked" heading="Chunked Shot Data">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true" @close="fetchSeasonShotmaps">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
              <div class="column">
                <label class="label">Sample Size</label>
                <div class="control">
                  <input type="number" class="input" min="5" max="30" step="1" v-model="RollingLimit" v-on:change="fetchGraphStats()">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildChunkedChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
    <section id="rolling">
       <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Rolling" heading="Rolling Shot Data">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true" @close="fetchSeasonShotmaps">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
              <div class="column">
                <label class="label">Sample Size</label>
                <div class="control">
                  <input type="number" class="input" min="5" max="30" step="1" v-model="RollingLimit" v-on:change="fetchGraphStats()">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildRollingChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
    <section id="cumulative">
       <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Cumulative" heading="Cumulative Shot Data">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildCumulativeChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import simpleheat from '../../../store/modules/simpleheat/simpleheat'
import Chart from 'vue-bulma-chartjs'
import Multiselect from 'vue-multiselect'
import TeamShotMap from '../shots-heatmap-team'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    'simpleheat': simpleheat,
    TeamShotMap,
    Multiselect,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      ShotTypeOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      PlayerSelected: [],
      ShotTypeSelected: [],
      FilterSelected: 'so_total',
      BlurSelected: 25,
      RadiusSelected: 12,
      UseHeatmap: true,
      ShotsPlayerData: [],
      FilterHeadings: [],
      GameByGameData: [],
      MatchData: [],
      GraphPlayers: [],
      GraphData: [],
      ChunkedData: [],
      ChunkedPlayers: [],
      RollingData: [],
      CumulativeData: [],
      GameByGameFill: true,
      GameByGameTension: 0,
      RollingLimit: 5,
      GameByGameDataOptions: [
        {text: 'Goals', value: 'goals'},
        {text: 'On Net', value: 'so_on_net'},
        {text: 'Missed Net', value: 'so_missed_net'},
        {text: 'Blocked', value: 'so_blocked'},
        {text: 'Total Attempts', value: 'so_total'},
        {text: 'On Net %', value: 'so_on_net_percentage'},
        {text: 'SH%', value: 'so_goal_percentage'}
      ],
      GameByGameDataSelected: 'so_total',
      ShotsPlayerHeadings: [
        'Player',
        'GP',
        'G',
        'On Net',
        'Missed',
        'Blocked',
        'OnNet%',
        'SH%',
        'Total',
        'OnNetAvg',
        'ShotAvg'
      ],
      ShotsPlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'G', value: 'goals'},
        {text: 'On Net', value: 'so_on_net'},
        {text: 'Missed', value: 'so_missed_net'},
        {text: 'Blocked', value: 'so_blocked'},
        {text: 'OnNet%', value: 'so_on_net_percentage'},
        {text: 'SH%', value: 'so_goal_percentage'},
        {text: 'Total', value: 'so_total'},
        {text: 'OnNetAvg', value: 'so_on_net_avg'},
        {text: 'ShotAvg', value: 'so_total_avg'}
      ],
      TeamShotDiffData: [],
      TeamShotDiffHeadings: [
        'Player',
        'Home Team',
        'Away Team',
        'Date',
        'CF',
        'CA',
        'Diff',
        'CF%'
      ],
      PlayerShotDiffData: [],
      PlayerShotDiffHeadings: [
        'Player',
        'GP',
        'CF',
        'CA',
        'Diff',
        'CREL',
        'CF%'
      ],
      PlayerShotmapData: [],
      PlayerShotmapHeadings: [
        'Player',
        'Shot Id',
        'Shot Type',
        'Shot Location'
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    sortByShotsData: function () {
      return _.orderBy(this.ShotsPlayerData, this.FilterSelected, ['desc'])
    },
    sortByTeamShotDiffData: function () {
      return _.orderBy(this.TeamShotDiffData, 'id', ['asc'])
    },
    sortByPlayerShotDiffData: function () {
      return _.orderBy(this.PlayerShotDiffData, 'c_rel', ['desc'])
    },
    sortByPlayerShotmapData: function () {
      return _.orderBy(this.PlayerShotmapData, 'shot_id', ['desc'])
    },
    sortGameByGameData: function () {
      return _.orderBy(this.GameByGameData, 'shot_id', ['desc'])
    },
    sortByShotsDataChart: function () {
      let orderedData = this.sortByShotsData
      return _.map(orderedData, this.FilterSelected)
    },
    sortByTeamShotDiffDataChart: function () {
      let orderedData = this.sortByTeamShotDiffData
      return _.map(orderedData, 'cf_percent')
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByShotsData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByShotsDataChart,
        label: 'Shots - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    chartTeamDiffData: function () {
      let playerLabels = []
      for (var label of this.TeamShotDiffData) {
        if (label.match_date !== '2018-2019') {
          playerLabels.push(label.match_date)
        }
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByTeamShotDiffDataChart,
        label: 'Team Shot Differential - CF % ',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(0, 225, 225, 1)',
        pointBorderColor: 'rgba(0, 225, 255, 1)',
        pointBackgroundColor: 'rgba(0, 225, 255, 1)',
        fill: false
      }]
      return data
    },
    buildChartData: function () {
      let matchLabels = []
      for (var label of this.MatchData) {
        matchLabels.push(label.formatted_date)
      }

      let customData = []
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
      // console.log(colour)
        customData.push({data: this.buildData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      // console.log(JSON.stringify(customData))
      // data.datasets = customData
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      return data
    },
    buildChunkedChartData: function () {
      let matchLabels = []
      let customData = []
      for (var label of this.ChunkedData) {
        matchLabels.push(label.formatted_date)
      }
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
        // console.log(colour)
        customData.push({data: this.buildChunkedData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      // console.log(data)
      return data
    },
    buildRollingChartData: function () {
      let matchLabels = []
      let customData = []
      for (var label of this.RollingData) {
        matchLabels.push(label.formatted_date)
      }
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
        // console.log(colour)
        customData.push({data: this.buildRollingData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      // console.log(data)
      return data
    },
    buildCumulativeChartData: function () {
      let matchLabels = []
      let customData = []
      for (var label of this.CumulativeData) {
        matchLabels.push(label.formatted_date)
      }
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
        // console.log(colour)
        customData.push({data: this.buildCumulativeData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      // console.log(data)
      return data
    }
  },
  methods: {
    buildData (_name) {
      let results = []
      for (var v of _.filter(this.GraphData, ['player', _name])) {
        switch (this.GameByGameDataSelected) {
          case 'goals':
            results.push(v.goals)
            break
          case 'so_on_net':
            results.push(v.so_on_net)
            break
          case 'so_missed_net':
            results.push(v.so_missed_net)
            break
          case 'so_blocked':
            results.push(v.so_blocked)
            break
          case 'so_total':
            results.push(v.so_total)
            break
          case 'so_on_net_percentage':
            results.push(v.so_on_net_percentage)
            break
          case 'so_goal_percentage':
            results.push(v.so_goal_percentage)
            break
        }
      }
      return results
    },
    buildChunkedData (_name) {
      let results = []
      for (var v of _.filter(this.ChunkedPlayers, ['player', _name])) {
        switch (this.GameByGameDataSelected) {
          case 'goals':
            results.push(v.goals)
            break
          case 'so_on_net':
            results.push(v.so_on_net)
            break
          case 'so_missed_net':
            results.push(v.so_missed_net)
            break
          case 'so_blocked':
            results.push(v.so_blocked)
            break
          case 'so_total':
            results.push(v.so_total)
            break
          case 'so_on_net_percentage':
            results.push(v.so_on_net_percentage)
            break
          case 'so_goal_percentage':
            results.push(v.so_goal_percentage)
            break
        }
      }
      return results
    },
    buildRollingData (_name) {
      let results = []
      for (var game of this.RollingData) {
        // console.log('Searching:' + JSON.stringify(game))
        for (var v of game.player_data) {
          if (v.player === _name) {
            // console.log('Found Player: ' + v.player)
            switch (this.GameByGameDataSelected) {
              case 'goals':
                results.push(v.goals)
                break
              case 'so_on_net':
                results.push(v.so_on_net)
                break
              case 'so_missed_net':
                results.push(v.so_missed_net)
                break
              case 'so_blocked':
                results.push(v.so_blocked)
                break
              case 'so_total':
                results.push(v.so_total)
                break
              case 'so_on_net_percentage':
                results.push(v.so_on_net_percentage)
                break
              case 'so_goal_percentage':
                results.push(v.so_goal_percentage)
                break
            }
          }
        }
      }
      return results
    },
    buildCumulativeData (_name) {
      let results = []
      for (var game of this.CumulativeData) {
        // console.log('Searching:' + JSON.stringify(game))
        for (var v of game.player_data) {
          if (v.player === _name) {
            // console.log('Found Player: ' + v.player)
            switch (this.GameByGameDataSelected) {
              case 'goals':
                results.push(v.goals)
                break
              case 'so_on_net':
                results.push(v.so_on_net)
                break
              case 'so_missed_net':
                results.push(v.so_missed_net)
                break
              case 'so_blocked':
                results.push(v.so_blocked)
                break
              case 'so_total':
                results.push(v.so_total)
                break
              case 'so_on_net_percentage':
                results.push(v.so_on_net_percentage)
                break
              case 'so_goal_percentage':
                results.push(v.so_goal_percentage)
                break
            }
          }
        }
      }
      return results
    },
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      }

      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shots', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.ShotsPlayerData = response.data.shots
            this.PlayerShotDiffData = response.data.shot_differentials_player
            this.TeamShotDiffData = response.data.shot_differentials_team
            this.GameByGameData = response.data.game_by_game
            this.MatchData = response.data.game_by_game.match_dates
            this.GraphPlayers = response.data.game_by_game.graph_players
            this.GraphData = response.data.game_by_game.graph_data
            this.fetchGraphStats()
          },
          response => {}
        )
    },
    fetchGraphStats () {
      this.fetchChunkedStats()
      this.fetchRollingStats()
      this.fetchCumulativeStats()
    },
    fetchChunkedStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      }

      console.log('Rolling Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shots-chunked', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.ChunkedData = response.data.chunked_data
            this.ChunkedPlayers = response.data.chunked_players
          },
          response => {}
        )
    },
    fetchRollingStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      }

      console.log('Rolling Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shots-rolling', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.RollingData = response.data.rolling_games
            // this.RollingPlayers = response.data.rolling_players
          },
          response => {}
        )
    },
    fetchCumulativeStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      }

      console.log('Rolling Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shots-cumulative', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.CumulativeData = response.data.rolling_games
            // this.RollingPlayers = response.data.rolling_players
          },
          response => {}
        )
    },
    fetchSeasonShotmaps () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'player': JSON.stringify(this.PlayerSelected),
        'shot_type': JSON.stringify(this.ShotTypeSelected)
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shotmaps', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.PlayerShotmapData = response.data.player_shot_locations
            this.renderKey()
            if (this.UseHeatmap) {
              this.renderHeatmap()
            } else {
              this.renderZoneMap(this.PlayerShotmapData)
            }
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }

            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let player = response.data.cardiff_players
            this.PlayerOptions.push({name: 'All', id: 0})
            for (var p = 0; p < player.length; p++) {
              this.PlayerOptions.push({name: player[p].number + ' ' + player[p].surname, id: player[p].id})
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: 1})
            this.SituationOptions.push({text: 'Power Play', value: 2})
            this.SituationOptions.push({text: 'Short Handed', value: 3})
            this.SituationOptions.push({text: 'Empty Net', value: 4})
            this.SituationOptions.push({text: '--Not avalible yet - Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              // this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})

            this.ShotTypeOptions.push({name: 'All', id: 'All'})
            this.ShotTypeOptions.push({name: 'Goal', id: 'Goal'})
            this.ShotTypeOptions.push({name: 'On Net', id: 'OnNet'})
            this.ShotTypeOptions.push({name: 'Missed Net', id: 'MissedNet'})
            this.ShotTypeOptions.push({name: 'Blocked', id: 'Blocked'})
          }
        )
    },
    renderHeatmap () {
      var canvas = this.$refs.player_shot_canvas
      let shotLocations = []
      for (var shots of this.PlayerShotmapData) {
        shotLocations.push(JSON.parse(shots.shot_location))
      }
      setTimeout(() => {
        var heat = simpleheat(canvas).data(shotLocations)
        heat.radius(this.RadiusSelected, this.BlurSelected)
        heat.draw()
      }, 2004)
    },
    renderZoneMap (locatonData) {
      /*eslint-disable */
      var canvas = this.$refs.player_shot_canvas
      var ctx = canvas.getContext('2d')

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      let colour = '#2F4858C9'
      let centerPos = [160, 76, 280, 200]

      let outsideZonePos = [5, 389, 590, 140]

      let behindNetPos = [5, 0, 590, 75]

      let leftOutsidePos = [5, 76, 160, 200]

      let rightOutsidePos = [440, 76, 155, 200]

      let leftPointInit = [5, 275]
      let leftPointLines = [{x: 5, y: 275}, {x: 165, y: 275}, {x: 180, y: 385}, {x: 5, y: 385}, {x: 5, y: 275}]

      let centerPointInit = [165, 275]
      let centerPointLines = [{x: 165, y: 275}, {x: 440, y: 275}, {x: 420, y: 385}, {x: 180, y: 385}, {x: 165, y: 275}]

      let rightPointInit = [440, 275]
      let rightPointLines = [{x: 440, y: 275}, {x: 595, y: 275}, {x: 595, y: 385}, {x: 420, y: 385}, {x: 440, y: 275}]

      this.drawRect(ctx, colour, centerPos)
      this.drawRect(ctx, colour, outsideZonePos, '12px', 1)
      this.drawRect(ctx, colour, behindNetPos)
      this.drawRect(ctx, colour, leftOutsidePos)
      this.drawRect(ctx, colour, rightOutsidePos)

      this.drawCustom(ctx, colour, leftPointInit, leftPointLines)
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines)
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines)

      for (var shots of locatonData) {
          let circlePos = []
          let decode = JSON.parse(shots.shot_location)
          // console.log(decode)
          circlePos[0] = decode[0]
          circlePos[1] = decode[1]
          if (shots.shot_type === 'OnNet'){
            this.drawCircle(ctx, '#D90908F2', circlePos, 6)
          }
          if (shots.shot_type === 'Blocked'){
            this.drawCircle(ctx, '#6800e8', circlePos, 4)
          }
          if (shots.shot_type === 'MissedNet'){
            this.drawCircle(ctx, '#e8a600', circlePos, 4)
          }
          if (shots.shot_type === 'Goal'){
            this.drawCircle(ctx, '#0fe800', circlePos, 8)
          }
      }
    /*eslint-enable*/
    },
    renderKey () {
      var canvas = this.$refs.shotmap_key
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.drawCircle(ctx, '#0fe800', [50, 10], 8)
      this.drawCircle(ctx, '#D90908F2', [100, 10], 6)
      this.drawCircle(ctx, '#e8a600', [150, 10], 4)
      this.drawCircle(ctx, '#6800e8', [200, 10], 4)
      this.drawText(ctx, 'Goal', [35, 30], '12px')
      this.drawText(ctx, 'On Net', [85, 30], '12px')
      this.drawText(ctx, 'Missed', [136, 30], '12px')
      this.drawText(ctx, 'Blocked', [185, 30], '12px')
    },
    drawRect (ctx, color, position, text, textPos, fontSize = '26px', lineWidth = 3) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = lineWidth
      ctx.fillRect(position[0], position[1], position[2], position[3])
      ctx.strokeRect(position[0], position[1], position[2], position[3])
      ctx.closePath()
    },
    drawText (ctx, text, textPosition, textSize = '26px') {
      ctx.beginPath()
      ctx.font = textSize + ' sans-serif'
      ctx.fillStyle = 'rgba(0, 0, 0, 1)'
      ctx.fillText(text, textPosition[0], textPosition[1])
      ctx.closePath()
    },
    drawCustom (ctx, color, initPos, movePoints) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = 'white'
      ctx.moveTo(initPos[0], initPos[1])
      // Loop over move points
      for (var prop of movePoints) {
        ctx.lineTo(prop.x, prop.y)
      }
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    },
    drawCircle (ctx, color, position, radius, lineWidth = 2) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = lineWidth
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
    // this.fetchSeasonShotmaps()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// shots.vue?baef4d64